
const getTrainingValues = (backendObj, key) => {
  return key in backendObj ? backendObj[key] : false;
}


export default(getTrainingValues)